<script lang="ts" setup>
import { cva, type VariantProps } from 'class-variance-authority'
import { computed } from 'vue'

import { cn } from '../../../..'

const indicatorVariants = cva('atabix-indicator', {
  variants: {
    variant: {
      success: 'atabix-indicator--success',
      warning: 'atabix-indicator--warning',
      error: 'atabix-indicator--error',
      custom: 'atabix-indicator--custom',
    },
  },
})

export type AIndicatorVariant = VariantProps<typeof indicatorVariants>

export interface AIndicatorProperty {
  variant: AIndicatorVariant['variant']
}
// Props
const property = defineProps<AIndicatorProperty>()
// end Props

// Emits
// end Emits

// Refs
// end Refs

// Computed
const computedClass = computed(() => {
  switch (property.variant) {
    case 'warning': {
      return cn(indicatorVariants({ variant: 'warning' }))
    }
    case 'error': {
      return cn(indicatorVariants({ variant: 'error' }))
    }
    case 'custom': {
      return cn(indicatorVariants({ variant: 'custom' }))
    }
    // eslint-disable-next-line unicorn/no-useless-switch-case
    case 'success':
    default: {
      return cn(indicatorVariants({ variant: 'success' }))
    }
  }
})
// end Computed

// Functions
// end Functions

// Async Api functions
// end Async Api functions

// Lifecycle Hooks / Init
// end Lifecycle Hooks / Init
</script>

<template>
  <div :class="computedClass">
    <slot name="default" />
  </div>
</template>

<style lang="scss" scoped>
/* stylelint-disable-next-line block-no-empty */
.atabix-indicator {
  @apply w-2;
  @apply h-2;
  @apply flex;
  @apply rounded-full;
  @apply bg-red-700;
}

.atabix-indicator--success {
  @apply bg-[#22C55E];
}

.atabix-indicator--warning {
  @apply bg-[#F97316];
}

.atabix-indicator--error {
  @apply bg-[#EF4444];
}

.atabix-indicator--custom {
  @apply bg-[#FF00C7];
}
</style>
